<template>
  <div class="search-list">
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Resultados de Búsqueda">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="searchResults" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'searchList/getField',
  mutationType: 'searchList/updateField',
});

export default {
  name: 'SearchList',
  components: {
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal
  ],
  data: () => {
    return {
      fields: [
        { key: 'nombre' },
        { 
          key: 'search',
          label: 'Coincidencia'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'searchResults',
      'nombre',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ])
  },
  created() {
    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('searchList/getSearchResults')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    consultar(item) {
      switch (parseInt(item.objetoTipoId)) {
        case 1:
          this.$router.push({ name: 'EventoDatos', 
                            params: { id: item.id }});
          break;
        case 2:
          this.$router.push({ name: 'ParticipanteDatos', 
                          params: { 
                            eventoId: item.eventoId, 
                            id: item.id 
                          }});
          break;
      }
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
